import { createContext } from 'react';

/**
 * Stable React context instance (separate module so Vite HMR does not recreate
 * the context when AppContext.tsx hot-reloads).
 */
export const AppContext = createContext<unknown>(null);
